import React from 'react';
import { CTAButton } from './CTAButton';
import { Shield, Lock } from 'lucide-react';
export function PriceBlock() {
  return <section id="precio" className="bg-brand-navy text-white py-20 md:py-32 px-4 border-t-4 border-brand-gold" data-id="element-99">
      <div className="max-w-4xl mx-auto text-center space-y-12" data-id="element-100">
        <div className="space-y-6" data-id="element-101">
          <h2 className="font-heading text-4xl md:text-5xl font-bold text-white" data-id="element-102">
            Toma el control tú misma.
          </h2>
          <p className="font-body text-xl text-gray-300 max-w-2xl mx-auto" data-id="element-103">
            Hoy puedes obtener el kit completo por menos de lo que cuesta una
            cena afuera. No pagues a un abogado o a una agencia.
          </p>
        </div>

        <div className="bg-white text-brand-navy p-8 md:p-12 rounded-3xl shadow-2xl max-w-2xl mx-auto relative" data-id="element-104">
          <div className="absolute top-0 left-1/2 -translate-x-1/2 -translate-y-1/2 bg-red-600 text-white px-6 py-2 rounded-full font-bold uppercase tracking-wide text-sm shadow-lg" data-id="element-105">
            Oferta por tiempo limitado
          </div>

          <div className="flex flex-col items-center justify-center space-y-4 mb-8" data-id="element-106">
            <div className="flex items-center gap-4 text-gray-400 font-bold text-2xl line-through decoration-red-500 decoration-4" data-id="element-107">
              <span data-id="element-108">$3,000</span>
              <span data-id="element-109">$1,500</span>
              <span data-id="element-110">$27</span>
            </div>
            <div className="text-center" data-id="element-111">
              <span className="block text-sm font-bold text-brand-gold uppercase tracking-widest mb-2" data-id="element-112">
                Precio con Descuento
              </span>
              <div className="flex items-start justify-center" data-id="element-113">
                <span className="text-4xl font-bold mt-2" data-id="element-114">$</span>
                <span className="text-8xl font-black font-heading tracking-tighter" data-id="element-115">
                  6
                </span>
                <span className="text-2xl font-bold mt-2" data-id="element-116">.39</span>
              </div>
              <span className="text-gray-500 font-medium" data-id="element-117">
                USD / Pago Único
              </span>
            </div>
          </div>

          <div className="space-y-6" data-id="element-118">
            <CTAButton href="https://claridaddiaria.com/cart/43035029012546:1" className="w-full text-xl py-5" data-id="element-119">
              ¡QUIERO SER LA JEFA DE MI CRÉDITO AHORA!
            </CTAButton>

            <div className="flex items-center justify-center gap-6 text-sm text-gray-500 font-medium" data-id="element-120">
              <div className="flex items-center gap-2" data-id="element-121">
                <Shield className="w-5 h-5 text-green-500" data-id="element-122" />
                <span data-id="element-123">Pago Seguro</span>
              </div>
              <div className="flex items-center gap-2" data-id="element-124">
                <Lock className="w-5 h-5 text-green-500" data-id="element-125" />
                <span data-id="element-126">Acceso Instantáneo</span>
              </div>
            </div>

            <p className="text-center text-brand-navy font-bold text-lg pt-4 border-t border-gray-100" data-id="element-127">
              Tu futuro hogar te está esperando.
            </p>
          </div>
        </div>
      </div>
    </section>;
}